import { TaxRate } from '@melio/ar-domain';

import { AddTaxRateFormFields } from './types';

export const isTaxRateUpdated = (taxRate: TaxRate, taxRateFormFields: Omit<AddTaxRateFormFields, 'id'>) =>
  taxRate.rate !== taxRateFormFields.rate || taxRate.isDefault !== taxRateFormFields.isDefault;
